import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C04MultibuttonlayoutCTAProps = RenderingProps<
  C04MultibuttonlayoutCTAFields,
  C04MultibuttonlayoutCTAParams
>;

export type C04MultibuttonlayoutCTAFields = {
  Heading?: Field<string>;
  Icon?: KeyValuePair;
  Subheading?: Field<string>;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  ThirdCTA?: LinkField;
  FourthCTA?: LinkField;
};

export type C04MultibuttonlayoutCTAParams = {
  Theme?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
